import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './font/iconfont.css'
// 引入element
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from './util/element.js';
// 导入网络连接
import socket from './util/server.js';
// 导入axios
import Axios from 'axios'
import './style/app.css'
Axios.defaults.baseURL = '/api'
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 用于客服的接口
Vue.prototype.$axios = Axios
const server = Axios.create({
	baseURL: '/v1'
})
Vue.prototype.$server = server

// Axios.defaults.baseURL = 'http://kefu.tjztct.com'
// server.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
